import { useState } from 'react'
import { TextField, Typography, Button, Stack } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { SmartDialog } from '../../../generic/utilities/SmartDialog'

// Default: no known pending moves (RN15/R5 — behaves exactly as before this history).
const DEFAULT_PENDING_MOVES = { toCancel: 0, inProgress: 0 }

const CancelPartDialog = ({ open, onClose, onConfirm, pendingMoves = DEFAULT_PENDING_MOVES }) => {
  const [comment, setComment] = useState('')
  const { t_ } = useSmartTranslation()

  const handleConfirm = () => {
    onConfirm(comment)
    setComment('')
  }

  const handleClose = () => {
    setComment('')
    onClose()
  }

  const renderComponent = (
    <div style={{ padding: '1em' }}>
      {(pendingMoves.toCancel > 0 || pendingMoves.inProgress > 0) && (
        <Stack sx={{ marginBottom: 2 }} gap={1}>
          {pendingMoves.toCancel > 0 && (
            <Typography variant='body2' color='warning.main' align='left'>
              {t_('{{count}} pending movement(s) will be cancelled', { count: pendingMoves.toCancel })}
            </Typography>
          )}
          {pendingMoves.inProgress > 0 && (
            <Typography variant='body2' color='warning.main' align='left'>
              {t_('{{count}} movement(s) in progress will be aborted', { count: pendingMoves.inProgress })}
            </Typography>
          )}
        </Stack>
      )}
      <Typography variant='h6' align='left' sx={{ marginBottom: 2 }}>
        {t_('Please enter a reason for cancelling this part:')}
      </Typography>
      <TextField
        autoFocus
        margin='dense'
        type='text'
        fullWidth
        variant='outlined'
        multiline
        rows={5}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        inputProps={{ maxLength: 200 }}
      />
      <Typography variant='caption' align='right' display='block'>
        {comment.length}/200
      </Typography>
    </div>
  )

  const renderCustomButtons = (
    <Button
      variant='contained'
      color='primary'
      onClick={handleConfirm}
      // The reason is a path segment of part/cancel/{id}/{comment}: an empty one would
      // produce a trailing-slash URL that does not match the backend route (generic 404
      // instead of a meaningful validation), so require it before enabling Confirm.
      disabled={comment.trim() === ''}
      style={{ marginRight: '10px' }}
    >
      {t_('Confirm')}
    </Button>
  )

  return (
    <SmartDialog
      setOpen={open}
      cancel={false}
      accept={false}
      close
      closeCallback={handleClose}
      renderComponent={renderComponent}
      renderCustomButtons={renderCustomButtons}
      autoClose={false}
    />
  )
}

export default CancelPartDialog
